'use client'

import { ChakraProvider, createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'
import { ColorModeProvider } from './color-mode'

// Admin portal theme: Inter for UI text, tabular figures for numbers, and a
// slightly tighter radius/shadow scale than Chakra's defaults.
const adminConfig = defineConfig({
  globalCss: {
    'html, body': {
      fontFamily: 'body',
      bg: 'bg.canvas',
      color: 'fg.default',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
    'p, a': { fontFamily: 'body' },
    '::selection': { bg: 'brand.100' },
  },
  theme: {
    tokens: {
      fonts: {
        heading: { value: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif" },
        body: { value: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif" },
        mono: { value: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace" },
      },
      colors: {
        brand: {
          50: { value: '#eef4ff' },
          100: { value: '#dbe6fe' },
          200: { value: '#bfd3fe' },
          300: { value: '#93b4fd' },
          400: { value: '#608bfa' },
          500: { value: '#3b66f5' },
          600: { value: '#2549ea' },
          700: { value: '#1d38d7' },
          800: { value: '#1e30ae' },
          900: { value: '#1e2f89' },
        },
      },
      shadows: {
        card: { value: '0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.06)' },
        pop: { value: '0 12px 32px -8px rgba(16, 24, 40, 0.18)' },
      },
    },
    semanticTokens: {
      colors: {
        'bg.canvas': { value: '#f6f7f9' },
        'bg.surface': { value: '#ffffff' },
        'border.subtle': { value: '#eaecf0' },
        'fg.default': { value: '#101828' },
        'fg.muted': { value: '#475467' },
        'fg.subtle': { value: '#98a2b3' },
        brand: {
          solid: { value: '{colors.brand.600}' },
          contrast: { value: 'white' },
          fg: { value: '{colors.brand.700}' },
          muted: { value: '{colors.brand.100}' },
          subtle: { value: '{colors.brand.50}' },
          emphasized: { value: '{colors.brand.200}' },
          focusRing: { value: '{colors.brand.500}' },
        },
      },
    },
  },
})

const system = createSystem(defaultConfig, adminConfig)

export function Provider(props) {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  )
}
